import React from 'react';
export function HeroSection() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section className="bg-gradient-to-br from-purple-50 to-blue-50 py-20 md:py-28 relative overflow-hidden" data-id="element-152">
      {/* Geometric shapes for visual interest */}
      <div className="absolute top-0 right-0 w-64 h-64 bg-purple-200 rounded-bl-full opacity-20" data-id="element-153"></div>
      <div className="absolute bottom-0 left-0 w-48 h-48 bg-blue-200 rounded-tr-full opacity-20" data-id="element-154"></div>
      <div className="absolute top-1/4 left-1/4 w-16 h-16 bg-indigo-300 rotate-45 opacity-10 animate-bounce" style={{
      animationDuration: '3s'
    }} data-id="element-155"></div>
      <div className="absolute bottom-1/4 right-1/3 w-12 h-12 bg-purple-300 rounded-full opacity-20 animate-pulse" style={{
      animationDuration: '4s'
    }} data-id="element-156"></div>
      <div className="container mx-auto px-4 relative z-10" data-id="element-157">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-158">
          <div data-id="element-159">
            <div className="inline-block bg-gradient-to-r from-purple-600 to-blue-600 text-white text-sm font-medium px-4 py-1.5 rounded-full mb-6 shadow-sm" data-id="element-160">
              🚀 Now Accepting Applications
            </div>
            <h1 className="text-4xl md:text-5xl font-bold mb-6 leading-tight" data-id="element-161">
              Shape the Future of{' '}
              <span className="bg-clip-text text-transparent bg-gradient-to-r from-purple-600 to-blue-600" data-id="element-162">
                Maths Education
              </span>
            </h1>
            <p className="text-lg text-gray-700 mb-8 leading-relaxed max-w-xl" data-id="element-163">
              A collaborative research initiative empowering schools to shape
              the future of maths education, driving impactful learning and
              innovation with Eedi.
            </p>
            <div className="flex flex-wrap gap-4" data-id="element-164">
              <button onClick={() => scrollToSection('application-form')} className="px-6 py-3 rounded-lg bg-gradient-to-r from-purple-600 to-blue-600 text-white font-medium hover:opacity-90 transition-all transform hover:scale-105 duration-200 shadow-md" data-id="element-165">
                Apply Now
              </button>
              <button onClick={() => scrollToSection('key-benefits')} className="px-6 py-3 rounded-lg border-2 border-purple-600 text-purple-700 font-medium hover:bg-purple-50 transition-all transform hover:scale-105 duration-200" data-id="element-166">
                Learn More
              </button>
            </div>
          </div>
          <div className="flex justify-center" data-id="element-167">
            <div className="relative" data-id="element-168">
              <div className="absolute inset-0 bg-gradient-to-br from-purple-200/30 to-blue-200/30 rounded-lg blur-xl transform rotate-6" data-id="element-169"></div>
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/suRHLyT6weYf4S5jRJHkgs/Eedi_features.png" alt="Eedi Platform Features" className="rounded-lg shadow-xl max-w-full h-auto animate-float relative z-10" data-id="element-170" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}